import { Injectable } from '@angular/core';
import { from, type Observable } from 'rxjs';
import {
  type AdminOnboardingStepListDto,
  listAdminOnboardingStepsAsync,
  createAdminOnboardingStepAsync,
  type AdminOnboardingStepPostPutDto,
  updateAdminOnboardingStepAsync,
  deleteOnboardingStepAsync,
  type AdminOnboardingStepGetDto,
  findAdminOnboardingStepAsync,
} from '../../../../backend/main';
import type { DtoListService, ListPaginatedDTO, GetAllRequestParameters } from '@pct/ng-core-dto';
import { UNKNOWN_ITEM } from '@pct/ng-core-dto';
import { isNil } from '@pct/ts-typeguard';
import type { FilteredParams } from '../../../common/request/filtered-params';
import type { OnboardingStepFilter } from './onboarding-step-filter';
import { convertPaginationParams } from '../../../common/utils/table/convert-pagination-params';
import { mapSort } from '../../../common/request/map-sort';

type ListDto = AdminOnboardingStepListDto;

@Injectable()
export class OnboardingStepDtoService implements DtoListService<
  ListDto,
  FilteredParams<ListDto, OnboardingStepFilter>
> {
  getAll(
    param: GetAllRequestParameters<FilteredParams<ListDto, OnboardingStepFilter>>,
  ): Observable<ListPaginatedDTO<ListDto>> {
    return from(
      listAdminOnboardingStepsAsync({
        body: {
          pagination: convertPaginationParams(param.pagination),
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          sort: mapSort(param.parameters?.sort) as any,
          searchText: param.parameters?.filter?.searchText,
        },
      }).then(resp => resp.data),
    );
  }

  delete(id: string): Observable<void> {
    return from(deleteOnboardingStepAsync({ path: { id } }).then(resp => resp.data));
  }

  getDtoId(dto: ListDto): string;
  getDtoId(dto: ListDto | null | undefined): string | null | undefined;
  getDtoId(dto: Partial<ListDto> | null | undefined): string | null | undefined;
  getDtoId(dto: ListDto | Partial<ListDto> | null | undefined): string | null | undefined {
    if (isNil(dto)) {
      return dto;
    }
    return dto.id;
  }

  toString(dto: ListDto): string {
    return dto.title ?? UNKNOWN_ITEM;
  }

  getById(id: string): Observable<AdminOnboardingStepGetDto> {
    return from(findAdminOnboardingStepAsync({ path: { id } }).then(resp => resp.data));
  }

  create(data: AdminOnboardingStepPostPutDto): Observable<void> {
    return from(
      createAdminOnboardingStepAsync({ body: data }).then(() => {
        //VOID
      }),
    );
  }

  update(id: string, data: AdminOnboardingStepPostPutDto): Observable<void> {
    return from(
      updateAdminOnboardingStepAsync({ path: { id }, body: data }).then(resp => resp.data),
    );
  }
}
